/* global Vue */
import TreeEditor from './TreeEditor'

class Bridge {

	constructor(bridgeE, options) {
		options = Object.assign({
			depth: 1
		}, options)

		// 入力データの正規化
		const data = (value => {
			try {
				const data = JSON.parse(value)
				if (!Array.isArray(data)) return []
				return data
			} catch (e) {
				return []
			}
		})(bridgeE.value)

		this.bridgeE = bridgeE

		this.container = this.createContainer()
		this.app = new Vue({
			data() {
				return {
					value: {
						children: data
					},
					options
				}
			},
			el: this.container,
			components: {
				TreeEditor
			},
			template: `<TreeEditor v-model="value" v-bind="options" />`,
			watch: {
				value: {
					deep: true,
					handler () {
						bridgeE.value = JSON.stringify(this.value.children)
					}
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
